<template>
  <div>
    <div class="mian">
      <!-- 头部 -->
      <div class="top">
        <img src="../assets/images/头部框.png" alt="" />
        <div class="info">
          <span>流通信息</span>
        </div>
        <div class="num">
          <span>04</span>
        </div>
      </div>
      <div>
        <div class="goodsInfo goodsInfo2">
          <div class="goodsInfo-text">
            <div style="width: 55px">订单号</div>
            <div class="goodsInfo-text-num texts" style="margin-left: 34px">
              {{ list[0].op.op.shop_orderId }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div>收货人</div>
            <div class="goodsInfo-text-num texts" style="margin-left: 53px">
              {{
                list[0].op.op.receiver_name
                  ? list[0].op.op.receiver_name
                  : list[1].op.op.receiver_name
              }}
            </div>
          </div>
          <!-- <div class="goodsInfo-text">
            <div>
              价格
            </div>
            <div class="goodsInfo-text-num texts" style="margin-left: 65px;">
              {{ list[0].op.op.price }}元
            </div>
          </div> -->
          <div class="goodsInfo-text">
            <div style="width: 65px">时间</div>
            <div class="goodsInfo-text-num texts" style="margin-left: 24px">
              {{ list[0].op.op.created_date.slice(0, 10) }}
            </div>
          </div>
        </div>
        <div class="goods-characteristic">
          <div class="goods-characteristic-inner">
            <span @click="toBlockChain"> 区块链标识：{{ list[0].txid }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { ImagePreview } from "vant";
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  data() {
    return {
      listData: [],
      list: [],
    };
  },
  created() {
    this.listData = JSON.parse(window.localStorage.getItem("defalutObj"));
    console.log("liu", this.listData);
    this.list = this.listData.filter((item) => item.trace_name === "交易信息");
    this.list.forEach((item) => {
      this.list = item.msgItems;
    });
    console.log("liutong", this.list[0].op.op);
  },
  methods: {
    switch_image(img) {
      ImagePreview([img]);
    },
    toBlockChain() {
      this.$router.push(`/Look?ts=${this.list.ts}&txid=${this.list.txid}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.mian {
  position: relative;
  width: 608px;
  margin-bottom: 20px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  .top {
    position: relative;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .product {
    width: 638px;
    height: 828px;
    background-color: skyblue;
    padding: 172px 0 30px 56px;
    border: #02b152 solid 10px;
    .text {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 45px;
      margin-top: -13vw;
      .text-top {
        color: #007d5f;
        font-weight: bold;
        line-height: 0px;
        opacity: 1;
        font-size: 32px;
        margin-bottom: 30px;
      }
      .text-bottom {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #000000;
        opacity: 1;
      }
    }
    .picture {
      width: 496px;
      height: 818px;
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 34px 60px 0 50px;
    }
  }
  .goodsInfo2 {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;

    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 544px;
    height: 404px;
    border: 2px solid #f3f3f3;
    opacity: 1;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 36px;
    .goodsInfo-text-num {
      white-space: pre-line;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .texts {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;

      color: #000000;
      opacity: 1;
    }
    .goodsInfo-text {
      display: flex;
      margin-left: 20px;
    }
  }
  .goods-characteristic {
    margin: 0 auto;
    width: 536px;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .b-material {
    .swipe-wrap {
      width: 546px;
      height: 250px;

      margin: 0 auto;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
    .material {
      display: flex;
      justify-content: space-between;
      width: 548px;
      height: 49px;

      align-items: center;
      margin: 0 auto;
      border-bottom: 2px solid #e8e8e8;
      .dian {
        .m-title {
          width: 112px;
          height: 40px;
          font-weight: 400;
          line-height: 0px;
          margin-left: 15px;
          margin-top: 5px;
        }
        width: 12px;
        height: 12px;
        background: #000000;
        border-radius: 50%;
        opacity: 1;
        margin-right: -330px;
        font-size: 28px;
      }
      .date {
        width: 250px;
        height: 28px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 28px;
        color: #919ab1;
        opacity: 1;
      }
    }
  }
}
</style>